import { format } from 'date-fns';

export type BanPeriod = '1d' | '3d' | '7d' | '30d' | 'permanent';

export const BAN_PERIOD_OPTIONS: { value: BanPeriod; label: string }[] = [
  { value: '1d', label: '1 day' },
  { value: '3d', label: '3 days' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: 'permanent', label: 'Permanent' },
];

const BAN_PERIOD_HOURS: Record<string, number> = {
  '1d': 24,
  '3d': 72,
  '7d': 168,
  '30d': 720,
};

function isBanGroupActive(group: {
  ban_active?: boolean;
  banned?: boolean;
  ban_period?: string | null;
  ban_until?: string | null;
}): boolean {
  if (group.ban_active != null) return Boolean(group.ban_active);
  if (!group.banned) return false;
  if (group.ban_period === 'permanent' || !group.ban_until) return true;
  return new Date() < new Date(group.ban_until);
}

export function isShopBanActive(player: {
  shop_ban_active?: boolean;
  shop_banned?: boolean;
  shop_ban_period?: string | null;
  shop_ban_until?: string | null;
  banned?: boolean;
}): boolean {
  if (player.shop_banned != null || player.shop_ban_active != null) {
    return isBanGroupActive({
      ban_active: player.shop_ban_active,
      banned: player.shop_banned,
      ban_period: player.shop_ban_period,
      ban_until: player.shop_ban_until,
    });
  }
  return player.banned === true;
}

export function isAdminBanActive(player: {
  admin_ban_active?: boolean;
  admin_banned?: boolean;
  admin_ban_period?: string | null;
  admin_ban_until?: string | null;
}): boolean {
  return isBanGroupActive({
    ban_active: player.admin_ban_active,
    banned: player.admin_banned,
    ban_period: player.admin_ban_period,
    ban_until: player.admin_ban_until,
  });
}

export function isEffectivelyBanned(
  player: Parameters<typeof isShopBanActive>[0] & Parameters<typeof isAdminBanActive>[0]
): boolean {
  return isShopBanActive(player) || isAdminBanActive(player);
}

export function formatUnbanDisplay(banPeriod?: string | null, banUntil?: string | null): string {
  if (banPeriod === 'permanent' || !banUntil) return 'Permanent';
  const d = new Date(banUntil);
  if (Number.isNaN(d.getTime())) return 'Permanent';
  return format(d, 'MMM dd, yyyy HH:mm');
}

export function previewUnbanFromPeriod(banPeriod: BanPeriod | ''): string | null {
  if (!banPeriod) return null;
  if (banPeriod === 'permanent') {
    return 'No automatic unban. You must remove the Shop ban manually.';
  }
  const hours = BAN_PERIOD_HOURS[banPeriod];
  if (!hours) return null;
  const until = new Date(Date.now() + hours * 60 * 60 * 1000);
  return `Unban scheduled: ${format(until, 'MMM dd, yyyy HH:mm')}`;
}
